export function fixTime(time) {
  let fixedTime = new Date(time);
  return fixedTime.toLocaleTimeString("en-US");
}

export function fixDate(date) {
  let fixedDate = new Date(date);

  return !isNaN(fixedDate.getTime())
    ? fixedDate.toLocaleDateString("en-US")
    : "N/A";
}

export function getDateString(date) {
  const dateObj = new Date(date * 1);
  const day = dateObj.toLocaleDateString("en-US", { weekday: "long" }); // Wed
  const monthday = dateObj.getMonth() + 1 + "/" + dateObj.getDate(); // 5/31

  return { day, monthday };
}

export const refreshTimeout = 300000;

export const refreshAlertText =
  "There has been a change to todays schedule.  Please review before your next appointment.";
